import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import {
	getAuth,
	signInWithCustomToken,
	storage,
	ref,
	uploadBytes,
	getDownloadURL,
} from "../firebase"; //updateMetadata
import {
	API_URL,
	scroll,
	getValFromLS,
	fmtBytes,
	isTopSponsor,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Checkbox from "../components/Checkbox";
import InputFile from "../components/InputFile";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Steps from "./Steps";

const RegLogo = () => {
	const [details, setDetails] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [fileMsg, setFileMsg] = useState({});
	const [file, setFile] = useState(null);
	const [uploads, setUploads] = useState([]);
	const [status, setStatus] = useState(5);

	/*
    0 - error
    1 - complete (uploaded)
    2 - initializing
    3 - initialized
    4 - uploading
    5 - idle
  */

	const history = useHistory();
	const formElement = useRef(null);

	useEffect(() => {
		const init = async () => {
			if (getValFromLS("auth", true) && getValFromLS("order", true)) {
				const authFromLS = JSON.parse(getValFromLS("auth", true));
				const orderFromLS = JSON.parse(getValFromLS("order", true));

				const url = new URL(`${API_URL}/registrationLogoInit`);
				const params = {
					id: authFromLS.id,
					topSponsor: isTopSponsor(orderFromLS.level.id) ? "1" : "0",
				};
				url.search = new URLSearchParams(params);

				try {
					const response = await fetch(url, {
						method: "GET",
						cache: "no-store",
					});
					const json = await response.json();
					if (json && json.resp === 1) {
						setDetails({ ...details, id: json.id, uploaded: json.uploaded });
						handleFirebAuth(json.firebToken);
					} else if (json && json.resp === 2) {
						// skip logo for non top sponsors
						history.push("/registration/questions");
					} else {
						setAlert({
							type: json.resp === 2 ? "notice" : "error",
							text: json.text,
						});
					}
				} catch (error) {
					setAlert({
						type: "error",
						text: "An error has occurred.",
					});
				}

				scroll();
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleFirebAuth = (token) => {
		const auth = getAuth();
		signInWithCustomToken(auth, token)
			.then(async (userCredential) => {
				// Signed in userCredential.user;

				setAlert({});
			})
			.catch((error) => {
				setAlert({
					type: "error",
					text: `Error ${error.message} (${error.code}).`,
				});
			});
	};

	const handleInitialize = (e) => {
		setMsg({});

		//console.log(e.target.files[0]);

		if (e.target.files[0]) {
			const fileData = e.target.files[0];
			setStatus(2);
			setFileMsg({
				type: "working",
				text: "",
			});
			const reader = new FileReader();

			reader.onload = (loadEvt) => {
				if (reader.readyState === 2) {
					if (fileData.size > 5 * 1024 * 1024) {
						setStatus(0);
						setFileMsg({
							type: "error",
							text: `File upload size limited to around 5 MB.`,
						});
					} else if (
						fileData.type !== "image/jpeg" &&
						fileData.type !== "image/png" &&
						fileData.type !== "application/postscript"
					) {
						setStatus(0);
						setFileMsg({
							type: "error",
							text: `Accepted file types are .jpg, .png or eps formats.`,
						});
					} else {
						setFile(fileData);
						setStatus(3);
						setFileMsg({
							type: "notice",
							text: `File initialized (${fileData.type}${
								fileData.size ? `, ${fmtBytes(fileData.size)}` : ""
							})`,
						});
					}
				}
			};

			reader.readAsDataURL(e.target.files[0]);
		}
	};

	const handleUpload = async (e) => {
		e.preventDefault();
		setStatus(4);
		setFileMsg({
			type: "working",
			text: "",
		});

		let fileName = file.name;

		/*
      const metadata = {
        customMetadata: {
          name: "Logo",
        },
      };
    */

		const path = `bfcFiles/${details.id}/${fileName}`;

		const fileRef = ref(storage, path);
		const uploadTask = await uploadBytes(fileRef, file);
		const downloadUrl = await getDownloadURL(uploadTask.ref);
		//const updatedMetadata = await updateMetadata(fileRef, metadata);
		let newArray = uploads;
		newArray.push({
			name: "Logo",
			path,
			downloadUrl,
		});
		setUploads(newArray);
		setStatus(5);
		setFileMsg({});
		/*formElement.current.file.value = ""; can't use here, removing element form DOM after upload*/
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/registrationLogo`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "noupload") {
				data.append(key, value ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("uploads", JSON.stringify(uploads));
		data.append("auth", getValFromLS("auth", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push("/registration/questions");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>4</h1>
							<div>
								<p>
									It is helpful for us to have an recent verison of your
									corporate logo on file, please use the form below to upload
									one in an appropriate format. If you have any questions,
									please email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						{details.uploaded.length > 0 && (
							<table
								className="approved assigned"
								style={{ marginTop: "25px" }}
							>
								<thead>
									<tr>
										<th colSpan="3" className="hdg">
											Previously Uploaded Assets
										</th>
									</tr>
									<tr>
										<td className="left">File Name</td>
										<td style={{ width: "20%" }}>View</td>
									</tr>
								</thead>
								<tbody>
									{details.uploaded.map((item, index) => {
										return (
											<tr key={index}>
												<td className="left">{item.name}</td>
												<td>
													<a
														href={item.downloadUrl}
														target="_blank"
														rel="noreferrer"
													>
														<i className="fa fa-download fa-lg" />
													</a>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						)}

						<h3 style={{ marginTop: "25px", marginBottom: "25px" }}>
							Upload Logo
						</h3>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							{/* for 2027 all top sponsors need to upload a logo
								{uploads.length === 0 && (
									<div
										className="form-group checkbox"
										style={{ marginTop: "10px" }}
									>
										<Checkbox
											name="noupload"
											label={
												details.uploaded.length > 0
													? "Check to use your previously uploaded logo or to skip uploading at this time"
													: "Check if you don’t want to upload your logo at this time"
											}
											checked={false}
											click={handleUpdate}
										/>
									</div>
								)}
							*/}

							{uploads.length === 0 && !names.noupload && (
								<div className="form-group upload-container">
									<InputFile
										name="file"
										label="Upload Image File (JPG, PNG, EPS)"
										reqd={false}
										value={""}
										update={handleInitialize}
										errors={errors}
									/>

									{fileMsg.type ? (
										<div className="upload-status-container">
											<Msg data={fileMsg} inline={true} />
											{status === 3 && (
												<button
													type="button"
													className="btn-alt"
													onClick={(e) => handleUpload(e)}
												>
													Upload File
												</button>
											)}
										</div>
									) : (
										<div className="empty" />
									)}
								</div>
							)}

							{uploads.length > 0 && (
								<div className="form-group one">
									<div>
										<label htmlFor="url" className="control-label">
											<span>
												<i className="fa fa-check success"></i> &nbsp;File
												uploaded, click the submit logo button below to continue
												to next step.
											</span>
										</label>

										{/*uploads.map((url, index) => {
                      return (
                        <input
                          key={index}
                          type="text"
                          value={url}
                          className="form-control"
                          readOnly={true}
                          style={{ marginTop: index === 0 ? "5px" : "7.5px" }}
                        />
                      );
                    })*/}
									</div>
								</div>
							)}

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									{(uploads.length > 0 || names.noupload) && (
										<Submit submit="Submit Logo & Continue" />
									)}
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Steps on={4} user={JSON.parse(getValFromLS("auth", true))} />
					</div>
				</>
			)}
		</>
	);
};

export default RegLogo;
